import { UseQueryResult, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  InvestmentsCachePullOperationStatus,
  InvestmentsCachePullResponse,
  InvestmentsRuntimeReloadResponse,
  InvestmentsRuntimeStatusResponse,
  InvestmentsPublicationStatus,
  fetchInvestmentsCachePullStatus,
  fetchInvestmentsRuntimeStatus,
  fetchInvestmentsPublicationStatus,
  pullInvestmentTickerFromBucket,
  pullInvestmentsCache,
  reloadInvestmentsRuntime,
} from "@features/investments/api";

export const runtimeStatusQueryKey = ["investments", "runtime-status"] as const;
export const cachePullStatusQueryKey = ["investments", "cache-pull-status"] as const;
export const publicationStatusQueryKey = ["investments", "publication-status"] as const;

export function useInvestmentsRuntimeStatusQuery(): UseQueryResult<InvestmentsRuntimeStatusResponse, Error> {
  return useQuery({
    queryKey: runtimeStatusQueryKey,
    queryFn: fetchInvestmentsRuntimeStatus,
    retry: false,
  });
}
export function useInvestmentsPublicationStatusQuery():UseQueryResult<InvestmentsPublicationStatus,Error>{return useQuery({queryKey:publicationStatusQueryKey,queryFn:fetchInvestmentsPublicationStatus,retry:false})}

export function useReloadInvestmentsRuntimeMutation() {
  const queryClient = useQueryClient();

  return useMutation<InvestmentsRuntimeReloadResponse, Error, void>({
    mutationFn: () => reloadInvestmentsRuntime(),
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: ["investments"] });
    },
  });
}

export function useInvestmentsCachePullStatusQuery(enabled: boolean): UseQueryResult<InvestmentsCachePullOperationStatus, Error> {
  return useQuery({
    queryKey: cachePullStatusQueryKey,
    queryFn: fetchInvestmentsCachePullStatus,
    enabled,
    refetchInterval: enabled ? 2000 : false,
    retry: false,
  });
}

export function usePullInvestmentsCacheMutation() {
  return useMutation<InvestmentsCachePullOperationStatus, Error, void>({
    mutationFn: () => pullInvestmentsCache(),
  });
}

export function usePullInvestmentTickerFromBucketMutation() {
  const queryClient = useQueryClient();

  return useMutation<InvestmentsCachePullResponse, Error, string>({
    mutationFn: (ticker: string) => pullInvestmentTickerFromBucket(ticker),
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: ["investments"] });
    },
  });
}
